import * as yup from "yup";

export const PayrollQPIPEarningsDialogueSetupValidationSchema = yup
	.object()
	.shape({
		earningId: yup.string().required("Earning is required"),
		effectiveDate: yup.string().required("Effective Date is required"),
	});
